const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const strategicResourcingDefaultValues = {
    base_case_and_counterfactual_scenario_engine: {
        counterfactual_scenario_type: '',
        current_capacity: '',
        current_demand: '',
        current_service_gap: '',
        current_cost_of_service: '',
        consequences_of_no_intervention: [],
        base_case_confidence_level: '',
        ...formMeta,
    },
    options_library_engine: {
        justification_of_option: {},
        ...formMeta,
    },
    economies_of_scale_engine: {
        economies_of_scale_assessment: '',
        ...formMeta,
    },
    special_procurement_actions_and_social_impact: {
        gender_responsive_procurement: '',
        social_benefits_value_reference: '',
        sustainability_and_environmental_compliance: '',
        legal_and_technical_due_diligence: '',
        ...formMeta,
    },
    demand_and_needs_validation_engine: {
        current_demand_units: 0,
        future_demand_horizon_year: 0,
        population_served: 0,
        growth_rate: 0,
        peak_capacity_required: 0,
        demand_confidence_level: '',
        current_service_gap: 0,
        future_gap_projected: 0,
        infrastructure_deficit_index: 0,
        ...formMeta,
    },
    cba_cea_intelligence_engine: {
        capital_cost: 0,
        annual_operating_cost: 0,
        economic_benefits: 0,
        social_benefits: 0,
        residual_value: 0,
        discount_rate: 0,
        analysis_period_years: 0,
        cost_per_beneficiary: 0,
        cost_per_household: 0,
        cost_per_service_unit: 0,
        cost_per_job_created: 0,
        cost_per_kilometre: 0,
        cost_per_outcome_achieved: 0,
        bcr: 0,
        irr: 0,
        npv: 0,

        ...formMeta,
    },
    financial_and_funding_strategy_engine: {
        funding_sources: [],
        funding_secured: '',
        funding_pending: '',
        funding_gap_percentage: '',
        private_sector_contribution: '',
        public_sector_contribution: '',
        revenue_model: '',
        innovative_financing_mechanisms: [],
        innovative_financing_structure_and_application: '',
        ...formMeta,
    },
    fiscal_sustainability_engine_ifsa: {
        operating_cost_coverage: 0,
        lifecycle_cost_coverage: 0,
        revenue_sufficiency: 0,
        fiscal_affordability_index: 0,
        funding_gap: 0,
        debt_exposure: 0,
        contingent_liability_exposure: '',
        ...formMeta,
    },

    risk_and_sensitivity_analysis_engine: {
        capex: 0,
        demand: 0,
        inflation: 0,
        revenue: 0,
        schedule_delay: 0,
        ...formMeta,
    },
    strategic_resourcing_decision_engine_core_output: {
        ...formMeta,
    },
    documents: {
        ...formMeta,
    },
    approval_submit: {
        ...formMeta,
    }
}

export type IStrategicResourcingFormValues = typeof strategicResourcingDefaultValues